// src/pages/hotelRoomCategories/HotelRoomCategories.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import HotelRoomCategoriesTable from "../../components/hotelRoomCategories/HotelRoomCategoriesTable";

const HotelRoomCategories = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            {/* data table Hotel Room Categories */}
            <HotelRoomCategoriesTable />
        </WrapperSection>
    );
};

export default HotelRoomCategories;
